<script lang="ts" setup>
// Feuille des notifications non lues (port de MobileNotifSheet) — branchée sur les vraies
// notifications (UnreadNotification), fournies par MobileApp. « Marquer comme lue » remonte
// à MobileApp (PATCH réel + re-fetch).
import type { UnreadNotification } from '~/interfaces/notifications/main';

defineProps<{ notifs: UnreadNotification[] }>();
const emit = defineEmits<{ close: []; read: [id: string | number] }>();
</script>

<template>
  <MobileSheet
    title="Notifications"
    height="78%"
    @close="emit('close')"
  >
    <div
      v-if="!notifs.length"
      class="gm-notif-empty"
    >
      <DsIcon
        name="check"
        :size="20"
      />
      Aucune notification non lue
    </div>
    <div
      v-else
      class="gm-notif-list"
    >
      <MobileNotifRow
        v-for="n in notifs"
        :key="n.id"
        :notification="n"
        @read="emit('read', $event)"
      />
    </div>
  </MobileSheet>
</template>
